import AttachmentItem from './AttachmentItem';
import CalendarShareButton from './CalendarShareButton';

function AttachmentPreviewRow({ attachments, onRemoveAttachment }) {
  if (attachments.length === 0) {
    return null;
  }

  const imageAttachments = attachments.filter(a => a.type === 'image');
  const calendarAttachments = attachments.filter(a => a.type === 'calendar' || a.type === 'calendar_share' || a.type === 'calendar_request');

  return (
    <div className="flex gap-2 overflow-x-auto overflow-y-visible pb-2 items-end">
      {imageAttachments.map(attachment => (
        <AttachmentItem
          key={attachment.id}
          attachment={attachment}
          onRemove={onRemoveAttachment}
        />
      ))}
      {calendarAttachments.map(attachment => (
        <CalendarShareButton
          key={attachment.id}
          clickable={false}
          attachment={attachment}
          showRemove={true}
          onRemove={() => onRemoveAttachment(attachment.id)}
        />
      ))}
    </div>
  );
}

export default AttachmentPreviewRow;
